import { render, staticRenderFns } from "./DataGeneralConsentDetail.vue?vue&type=template&id=73942828&scoped=true&"
import script from "./DataGeneralConsentDetail.vue?vue&type=script&lang=js&"
export * from "./DataGeneralConsentDetail.vue?vue&type=script&lang=js&"
import style0 from "./DataGeneralConsentDetail.vue?vue&type=style&index=0&id=73942828&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73942828",
  null
  
)

export default component.exports